const DEBUG_STORAGE_KEY = "ls_debug_auth_perf";
const isEnabled = () => {
    try {
        return localStorage.getItem(DEBUG_STORAGE_KEY) === "1";
    }
    catch {
        return false;
    }
};
const now = () => typeof performance !== "undefined" && performance.now
    ? performance.now()
    : Date.now();
export function createAuthPerformanceTrace(scope) {
    const enabled = isEnabled();
    const startedAt = now();
    const marks = [];
    const mark = (step, extra = {}) => {
        if (!enabled)
            return;
        marks.push({
            step,
            elapsedMs: Number((now() - startedAt).toFixed(1)),
            ...extra,
        });
    };
    const flush = (extra = {}) => {
        if (!enabled)
            return;
        const totalMs = Number((now() - startedAt).toFixed(1));
    };
    return { mark, flush };
}
